import * as Sentry from '@sentry/react';

export const initSentry = () => {
  // Disable Sentry in development mode
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.log('Sentry is disabled in development mode.');
    return;
  }

  const dsn = import.meta.env.VITE_SENTRY_DSN;
  const environment =
    import.meta.env.VITE_SENTRY_ENVIRONMENT ||
    import.meta.env.MODE ||
    'development';
  const release = import.meta.env.VITE_SENTRY_RELEASE;

  // Only initialize Sentry if DSN is provided
  if (!dsn) {
    // eslint-disable-next-line no-console
    console.warn('Sentry DSN not provided. Error tracking is disabled.');
    return;
  }

  Sentry.init({
    dsn,
    environment,
    release,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: environment === 'production' ? 0.1 : 1.0,
    // Session Replay
    replaysSessionSampleRate: environment === 'production' ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,
    // Set sample rate for profiling - this is relative to tracesSampleRate
    profilesSampleRate: environment === 'production' ? 0.1 : 1.0,
    // Filter out sensitive data
    beforeSend(event, hint) {
      // Filter out errors from browser extensions
      if (event.exception) {
        const error = hint.originalException;
        if (error && typeof error === 'object' && 'message' in error) {
          const errorMessage = String(error.message);
          if (
            errorMessage.includes('chrome-extension://') ||
            errorMessage.includes('moz-extension://') ||
            errorMessage.includes('safari-extension://')
          ) {
            return null;
          }
        }
      }
      return event;
    },
    // Configure which URLs to trace
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/.*\.itriahome\.com/,
      /^https:\/\/api\..*/,
    ],
  });
};

export default Sentry;
